export const FEEDBACK_STATUSES = ['new', 'in-progress', 'resolved', 'closed'] as const;

export type FeedbackStatus = (typeof FEEDBACK_STATUSES)[number];

const FEEDBACK_STATUS_LABELS: Record<FeedbackStatus, string> = {
  new: 'New',
  'in-progress': 'In Progress',
  resolved: 'Resolved',
  closed: 'Closed',
};

const FEEDBACK_STATUS_COLORS: Record<FeedbackStatus, string> = {
  new: '#6366f1',
  'in-progress': '#f59e0b',
  resolved: '#22c55e',
  closed: '#64748b',
};

export function isFeedbackStatus(value: string): value is FeedbackStatus {
  return (FEEDBACK_STATUSES as readonly string[]).includes(value);
}

export function getFeedbackStatusLabel(status: FeedbackStatus): string {
  return FEEDBACK_STATUS_LABELS[status];
}

export function getFeedbackStatusColor(status: FeedbackStatus): string {
  return FEEDBACK_STATUS_COLORS[status];
}
